import { LocationType } from '~/client/graph'
import {
  getLocationRootKind,
  IKindBearingLocation,
  locationTypeFromKind,
} from '~/client/src/shared/resources/domain/locationKind'

/** `loading_dock` → `Loading dock`: a project-added kind has no label this client knows. */
const humanizeKind = (slug: string): string => {
  const words = slug.replace(/_/g, ' ').trim()

  return words.charAt(0).toUpperCase() + words.slice(1)
}

/**
 * The "LOCATIONS (BY TYPE)" bucket for one permit location value (STX1-597).
 *
 * The value's `type` is a snapshot of the kind when the permit was saved, so a location
 * the project still has is bucketed by its live kind instead:
 *
 * - one of the twelve root kinds labels as the LocationType it corresponds to - the same
 *   string the widget showed when it read the snapshot, so nothing changes for a location
 *   that was never re-kinded;
 * - a project-added kind labels as its slug, humanised;
 * - a location with no kind, or a sibling resource, labels as its live resource type.
 *
 * A location `location` does not resolve falls back to the stored type, then to
 * `unknownLabel`.
 */
export function getLocationKindLabel(
  value: { type?: LocationType | null } | null | undefined,
  location: IKindBearingLocation | null | undefined,
  unknownLabel: string,
): string {
  if (location) {
    const rootKind = getLocationRootKind(location)
    if (rootKind) {
      return locationTypeFromKind(rootKind) ?? humanizeKind(rootKind)
    }

    if (location.type) return location.type
  }

  return value?.type || unknownLabel
}
